// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__oribU","title":"Footer_title__TQLDZ","column":"Footer_column__Ek6P5","text":"Footer_text__sn6WZ"};